module.exports = __webpack_public_path__ + "static/media/cs-chart-desire-feasible.9a2b485b.png";